// extracted by mini-css-extract-plugin
export default {"form":"LoginNew_form__PphyZ","input":"LoginNew_input__H1NUD"};